
import Vue, { PropType } from 'vue'
import RPHAnalogsList from 'rph/organisms/RPHAnalogsList/index.vue'
import RPHProductSpecification from 'rph/organisms/RPHProductSpecification/index.vue'
import RPHProductSpecs from 'rph/organisms/RPHProductSpecs/index.vue'
import RPHAd from 'rph/molecules/RPHAd/index.vue'

import { IProduct, IProductMnn, IProductTabs } from '~/types/DTO/products'
import RPHTabsList from 'rph/organisms/RPHTabsList/index.vue'

export default Vue.extend({
  name: 'RPHProductSpecsContainer',
  components: {
    RPHTabsList,
    RPHAnalogsList,
    RPHProductSpecification,
    RPHProductSpecs,
    RPHAd,
  },
  props: {
    data: {
      type: Object as PropType<IProduct>,
      required: true,
    },
  },
  computed: {
    banner(): any {
      const banners = this.$services.banners.getBannersByLocation(
        this.$store.getters['rph-banners/hotBanners'],
        this.$services.banners.locationHome,
      )
      if (banners.length) {
        return banners[Math.floor(Math.random() * banners.length)]
      } else {
        return {}
      }
    },
    analogsLink(): string {
      return this.data?.trade_name?.slug ? '/analogs/' + this.data.trade_name.slug : ''
    },
    analogsCount(): string {
      return this.$store.getters['rph-products/analogsCount']
    },
    analogs(): IProduct[] {
      return this.$store.getters['rph-products/analogs']
    },
    recommendedProducts(): IProduct[] {
      return this.$store.getters['rph-products/recommendedProducts']
    },
    product(): IProduct {
      return this.$store.getters['rph-products/product']
    },
    mnns(): IProductMnn[] {
      return Object.keys(this.product).length !== 0 ? this.product.specification.mnn : []
    },
    haveAnnotations(): boolean {
      const annotations = this.product.annotation
      return Object.values(annotations).some((item: any) => item !== '')
    },
  },
})
